import localConf from '@/local-conf';
import { UploadSceneType } from '@/types';

/** 各上传场景对应的接口 */
const SCENE_PATH: Record<UploadSceneType, string> = {
  [UploadSceneType.common]: '/MinioController/updateFile',
  [UploadSceneType.forum]: '/MinioController/forumUpdateFile',
  [UploadSceneType.secure]: '/MinioController/secureUpdateFile',
};

export default {
  /**
   * 上传资源
   * @param filePath - 本地资源地址
   * @param scene - 上传场景
   */
  fetchUpload: (
    filePath: string,
    scene: UploadSceneType = UploadSceneType.common
  ): Promise<string> => {
    return new Promise((reslove, reject) => {
      return uni.uploadFile({
        header: {
          "vendure-token": localConf.channel,
        },
        url: `${localConf.host}${SCENE_PATH[scene]}`,
        filePath,
        name: 'file',
        success: (res) => {
          return reslove(res.data);
        },
        fail: (err) => {
          console.log(err);
          return reject(err);
        },
      });
    });
  },
};
